import { autoserializeAs } from 'cerialize';

export class OAuthTokenModel {
    @autoserializeAs('access_token') public accessToken: string;
    @autoserializeAs('token_type') public tokenType: string;
    @autoserializeAs('expires_in') public expiresIn: number;
}
